// Temporarily disabled due to production runtime error: "useHead() was called without provide context"
// The Nuxt 4 plugin setup wrapper should provide context, but to unblock deploy,
// we no-op this plugin until we can reproduce and fix safely.
export default defineNuxtPlugin(() => {
  // no-op
})
